module.exports = __webpack_public_path__ + "static/media/System_supervisor.4edbdfea.svg";